<template>


  <div>
    <b-row class="d-flex align-items-end">

      <b-col class="col-10">

        <div>
          <h6>Exámenes Laboratorio</h6>

          <SearchOpts
            v-model="selectedLaboratorio"
            :searchService="laboratoriosService.getAllSns"
            :placeholder="'Buscar por código o por nombre'"
            :minChars="3"
            :omit="omitLaboratorios"
          />
        </div>
        
      </b-col>

      <b-col class="col-1">
        <b-button 
          class="" 
          variant="warning" 
          size="sm"
          @click="onAddLaboratorio"
        >
          <i class="fa-solid fa-plus"/>
        </b-button>
      </b-col>

    </b-row>

    <b-table
      v-if="laboratorios.length"
      :items="laboratorios"
      :fields="tableFields"
      class="text-center mt-2"
      responsive small
    >
      <template #cell(acciones)="data">
        
        <b-button
          variant="danger"
          size="sm"
          style="cursor: pointer"
          @click="removeItemLaboratorio(data.item.id)"
        >
          <font-awesome-icon
            icon="circle-xmark"
            style="color: rgb(255, 255, 255)"
          />
        </b-button>
      </template>
    </b-table>
  </div>

  
  
</template>

<script>
import { SearchOpts } from '@/shared/components';
import { laboratoriosService } from '@/views/laboratorio/services';
import { mapState } from "vuex";

export default {
  name: 'CrearDerivacionLaboratorio',

  components:{
    SearchOpts
  },


  data() {
    return {
      selectedLaboratorio: null,
      laboratorios: [],

      laboratoriosService,

      tableFields: [
        { key: "descripcion",  label: "Descripcion", thClass: "text-center" },
        { key: "acciones",     label: "acciones",    thClass : "text-center" },
      ]
    }
  },

  created() {

  },

  methods: {

    onAddLaboratorio(){

      const newLaboratorio = {
        id: this.selectedLaboratorio.id,
        codigo: this.selectedLaboratorio.codigo,
        descripcion: `${this.selectedLaboratorio.codigo} - ${this.selectedLaboratorio.descripcion}`,
        tipo: this.selectedLaboratorio.tipo
      }
      this.laboratorios.push(newLaboratorio);
      this.selectedLaboratorio = null;
    },

    removeItemLaboratorio(id){
      this.laboratorios = this.laboratorios.filter(item => item.id !== id);
    }
  },


  computed: {

    ...mapState({
      stData: state => state.derivaciones.modalCompletarDerivacion.zData,
    }),

    omitLaboratorios(){
      const omits = this.laboratorios.map(
        item => ({ id: item.id, token: null })
      );

      return omits;
    }
  },

  watch: {

    laboratorios: {
      deep: true,
      handler(newValue){
        this.$store.commit("setDerivacionesDataForm", { laboratorios: newValue  });
      }
    },


    stData:{
      deep: true,
      immediate: true,
      handler(newValue){
        this.laboratorios = [...newValue.laboratorios];
      }
    }
  }

}
</script>

<style>

</style>